import { getPlatform, isMax, isTelegram, PLATFORMS as PLATFORM_KINDS } from './detect';
import * as telegram from './telegram';
import * as max from './max';

// MAX must be checked before Telegram (Telegram SDK may be present as a stub in MAX WebView).
const PLATFORM_MODULES = [max, telegram];

export { getPlatform, isMax, isTelegram, PLATFORM_KINDS };
export { telegram, max };

export function detectPlatform() {
  return PLATFORM_MODULES.find((platform) => platform.isAvailable()) ?? null;
}

/**
 * Detect host, load only the matching SDK, then resolve the platform module.
 * @returns {Promise<typeof telegram | typeof max | null>}
 */
export async function detectPlatformAsync() {
  const kind = getPlatform();

  if (kind === PLATFORM_KINDS.MAX) {
    try {
      await max.loadMaxSdk();
    } catch (error) {
      console.warn('[Platform] MAX Bridge failed to load:', error);
    }
    if (max.isAvailable()) {
      return max;
    }
    // Bridge script may still be initializing; WebApp is often injected natively.
    if (isMax()) {
      return max;
    }
    return null;
  }

  if (kind === PLATFORM_KINDS.TELEGRAM) {
    try {
      await telegram.loadTelegramSdk();
    } catch (error) {
      console.warn('[Platform] Telegram SDK failed to load:', error);
    }
    return telegram.isAvailable() ? telegram : null;
  }

  return null;
}

export function getPlatformName(platform) {
  return platform?.PROVIDER ?? null;
}

export function getPlatformModule(provider) {
  if (provider === 'telegram') return telegram;
  if (provider === 'max') return max;
  return null;
}
